import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class ContentDataTask extends AbstractRequestTask {
  constructor(groupId = "") {
    super();

    this.groupId = groupId;
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/content/data`;
  }

  getParams() {
    const params = super.getParams();
    return {
      group_id: this.groupId,
      ...params,
      // user_hash: "",
    };
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default ContentDataTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/content/ContentDataTask.js